// Layout & density tokens — the values that were previously magic numbers scattered
// across pages (see docs/UI_STANDARDS.md §1.1: nine different navbar offsets).
//
// Kept separate from theme.js so the design system can be extended without
// touching a file that other branches are actively editing.

// Fixed AppBar height (MUI default desktop Toolbar) + the gap below it.
// AppShell composes these into its single top offset; pages NEVER re-apply it.
export const NAV_HEIGHT = 64;
export const CONTENT_TOP_GAP = 24;
export const CONTENT_TOP_OFFSET = NAV_HEIGHT + CONTENT_TOP_GAP; // 88px

// Vertical rhythm for tables/rows, in theme spacing units (1 = 8px).
export const DENSITY = {
    compact: { cellPaddingY: 0.75, cellPaddingX: 1.5, rowHeight: 40 },
    standard: { cellPaddingY: 1.25, cellPaddingX: 2, rowHeight: 52 },
    comfortable: { cellPaddingY: 2, cellPaddingX: 3, rowHeight: 64 },
};

export const DEFAULT_DENSITY = 'standard';

export const densityTokens = (density = DEFAULT_DENSITY) =>
    DENSITY[density] || DENSITY[DEFAULT_DENSITY];

// Page content frame.
export const PAGE_GUTTER = 2; // spacing units around page content
export const SECTION_GAP = 2.5; // gap between stacked page sections
